import AppBarNanoox from "./components/AppBarNanoox";
import FooterNanoox from "./components/FooterNanoox";
import "./NanooxLayout.css";

export default function NanooxLayout({ 
  children,modulos, page, setPage, generadores, historialControl, lastUpdate, umbrales ,
  o2PressureOk, versions, userLevel ,totalPages, nextPage, prevPage, password,setPassword,
  notificationOpen,
  setNotification_open,
  setNotification_msg,
  setNotification_status,
  translate ,handleClick ,openMenuIdioma ,handleCloseIdioma ,handleLanguageChange, idioma,
  onSelectCenter, showDashboard, setShowDashboard, version, setLoadingCenter, TemperaturaGlobal, AcumuladoO2Global, VoIoGlobal, medicionesGlobal,
  activeStage, onSelectGeneratorView, activeView, onViewChange, estado, hasComapGenerators
}) {

  const PropsAppbar = {
    translate ,handleClick ,openMenuIdioma ,handleCloseIdioma ,handleLanguageChange, idioma,
    generadores,
    historialControl,
    lastUpdate,
    page,
    setPage,
    modulos: modulos || [],
    totalPages,
    nextPage,
    prevPage,
    userLevel,
    password ,
    setPassword,
    notificationOpen,
    setNotification_open,
    setNotification_msg,
    setNotification_status,
    onSelectCenter, showDashboard, setShowDashboard, version, setLoadingCenter,VoIoGlobal, medicionesGlobal,
    activeView,onViewChange, onSelectGeneratorView, estado, hasComapGenerators
  }


  // console.log('generadores',generadores)

  return (
    <div className="nanoox-layout">
      <header className="nanoox-appbar">
        <AppBarNanoox {...PropsAppbar}/>
      </header>

      <div className="nanoox-content">
        <main           
          className={`nanoox-main ${
            activeView === "generador-o2" || activeView === "generador-o2-3d"
              ? "nanoox-main-no-scroll"
              : ""
          }`}>
            {children}
        </main>
      </div>
      {(activeView === "nanoox" || activeStage !== "generator") && (
        <footer className="nanoox-footer">
          <FooterNanoox 
            o2PressureOk={o2PressureOk}
            modulos={modulos}
            versions={versions}
            umbrales={umbrales}
            userLevel={userLevel}
            generadores={generadores}
            translate={translate}
            TemperaturaGlobal={ TemperaturaGlobal} AcumuladoO2Global={ AcumuladoO2Global} VoIoGlobal={ VoIoGlobal} medicionesGlobal={ medicionesGlobal}
          />
        </footer>
      )}
    </div>
  );
}
